module.exports = __webpack_public_path__ + "img/no-photo.8e831a01.png";